<template>
  <div
    :class="
      $style['promotion']
    "
    @click="onClick">
    <div :class="$style['promotion__inner']">
      <img alt="flower" :class="$style['promotion__background']" src="/images/promotions/amersfoort/1.svg">
      <img alt="flower" :class="$style['promotion__background']" src="/images/promotions/amersfoort/2.svg">

      <img alt="EVERYTHING 15% OFF OPENING AMERSFOORT" :class="$style['promotion__title']" src="/images/promotions//amersfoort/tekst.svg">
      <div :class="$style['promotion__subtitle']">
        CODE: AMERSFOORT
      </div>
      <btn
        v-if="(promotionData.link && promotionData.showLink) && shouldShow(promotionData.link)"
        aria-label="Go to promotion"
        icon-only="System/arrow-right-s-line"

        shape="round" />
    </div>
  </div>
</template>
<script>
import baseScript from './Shared/script'
export default {
  extends: baseScript
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  background-image: url('/images/promotions/amersfoort/background.webp');
  position: relative;
  container: promotion / inline-size;

  &__inner {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__title {
    width: 95.5cqw;
    margin-bottom: calc(var(--spacing) * 4.5);
    z-index: 1;
  }

  &__subtitle {
    font-size: 8cqw;
    color: var(--white);
    background-color: #EBB2D2;
    padding-inline: .5cqw;
    z-index: 1;

  }

  &__background {
    position: absolute;
    z-index: 0;
    width: 34cqw;
    height: 34cqw;
    object-fit: cover;
    object-position: center;

    &:first-of-type {
      top: 4cqw;
      left: 4cqw;
      animation: rotation 4s infinite linear;
    }

    &:nth-of-type(2) {
      bottom: 7cqw;
      right: 3.5cqw;
      animation: rotationreverse 4s infinite linear;
    }
  }
}

@keyframes rotation {
  0% {
    top: 4cqw;
    left: 4cqw;
  }

  33.33% {
    top: 7.5cqw;
    left: 21cqw;
  }

  66.66% {
    top: 24.5cqw;
    left: 9.5cqw;
  }

  100% {
    top: 4cqw;
    left: 4cqw;
  }

}

@keyframes rotationreverse {
  0% {
    bottom: 7cqw;
    right: 3.5cqw;
  }

  33.33% {
    bottom: 11cqw;
    right: 20cqw;
  }

  66.66% {
    bottom: 25.5cqw;
    right: 8.5cqw;
  }

  100% {
    bottom: 7cqw;
    right: 3.5cqw;
  }
}
</style>
